import React, { Component } from 'react';
import './App.css';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Contact from './components/Contact';
import Partners from './components/Partners';
import Index from './components/Index.container';
import ListAll from './components/ListAll.container';
import Recipe from './components/Recipe.container';
import Partner from './components/Partner.container';
import Maintenance from './components/Maintenance';
import { Switch, Route, Redirect } from 'react-router-dom';

class App extends Component {
  render() {
      return (
          <div className="app">
              <Header />
              <div className="app-content">
                  <Switch>
                      <Route path="/accueil/:page([0-9]+)" exact component={ListAll} />
                      <Route path="/recette/:label" exact component={Recipe} />
                      <Route path="/partenaire/:label" exact component={Partner} />
                      <Route path="/recettes" component={Index} />
                      <Route path="/partenaires" component={Partners} />
                      <Route path="/contact" component={Contact} />
                      <Redirect to="/accueil/1" />
                      {/*<Route path="/maintenance" component={Maintenance}></Route>*/}
                      {/*<Redirect to="/maintenance" />*/}
                  </Switch>
                  <Sidebar />
              </div>
          </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js